import { useState, memo } from "react";
import { Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import { useSupabaseUser } from "../../hooks/fetch";
import { GiftOutlined, MessageOutlined, SettingOutlined,  TeamOutlined, AppstoreOutlined, StarOutlined, BellOutlined, DollarOutlined, WalletOutlined } from "@ant-design/icons";
import "../../assets/styles/sidenav.css";

function SidenavPartner({ color }) {
  const { pathname, search } = useLocation();
  const page = pathname.replace("/", "");
  const [collapsed] = useState(false);

  // Keep hook call only if it triggers side-effects elsewhere; don't extract unused values
  useSupabaseUser();

  // Ant Design icons for all menu items for consistency
  const dashboardIcon = [<AppstoreOutlined style={{ fontSize: 20, color }} key={0} />];
  const clientsIcon = [<TeamOutlined style={{ fontSize: 20, color }} key={0} />];
  const sponsorsIcon = [<GiftOutlined style={{ fontSize: 20, color }} key={0} />];
  const reclamationsIcon = [<MessageOutlined style={{ fontSize: 20, color }} key={0} />];
  const reviewsIcon = [<StarOutlined style={{ fontSize: 20, color }} key={0} />];
  const settingsIcon = [<SettingOutlined style={{ fontSize: 20, color }} key={0} />];
  const revenuIcon = [<DollarOutlined style={{ fontSize: 20, color }} key={0} />];
  const paiementIcon = [<WalletOutlined style={{ fontSize: 20, color }} key={0} />];

  const isPaiementActive = pathname === "/Paiements";
  const isSettingsActive = pathname === "/Paramétres";
  const isRevenuActive = pathname === "/Revenu" || pathname.startsWith("/paiement/Client");
  // search est gardé pour stabilité du re-render (useLocation)
  void search;

  // No profile state needed in this component; kept user for potential auth actions

  return (
    <div className={`sidenav-root ${collapsed ? "collapsed" : ""}`}>
    

      <div className="brand">
        <div style={{ width: "100%", maxWidth: 300, position: "relative", zIndex: 1, display: "flex", justifyContent: "space-between", alignItems: "center", }}>
          <div className="brand-title" style={{ fontWeight: 700, fontSize: 30, letterSpacing: 2, marginBottom: 10, fontFamily: "Bruno Ace SC, sans-serif", textTransform: "uppercase", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 0, width: "100%", marginTop : 10, }}>
            <span style={{ color: "#222", fontWeight: 700, fontFamily: "Bruno Ace SC, sans-serif" }}>BATI</span>
            <span style={{ color: "#FFF", fontWeight: 700, fontFamily: "Bruno Ace SC, sans-serif" }}>LINK</span>
          </div>
        </div>
      </div>

      <hr />

      <div>
        <Menu
          theme="light"
          mode="inline"
          items={[
            { key: '1', label: (<NavLink to="/Dashboard"><span className="icon" style={{ background: page === "Dashboard" || page === "SubAdminDashboard" ? color : "" }}>{dashboardIcon}</span><span className="label">Tableau de bord</span></NavLink>) },
            { key: 'revenu', label: (<NavLink to="/Revenu"><span className="icon" style={{ background: isRevenuActive ? color : "" }}>{revenuIcon}</span><span className="label">Revenu</span></NavLink>) },
            { key: '2', label: (<NavLink to="/Clients"><span className="icon" style={{ background: page === "Clients" || page === "PartnerClients" ? color : "" }}>{clientsIcon}</span><span className="label">Les Clients</span></NavLink>) },
            { key: '6', label: (<NavLink to="/Sponsors"><span className="icon" style={{ background: page === "Sponsors" ? color : "" }}>{sponsorsIcon}</span><span className="label">Les sponsors</span></NavLink>) },
            { key: 'paiement', label: (<NavLink to="/Paiements"><span className="icon" style={{ background: isPaiementActive ? color : "" }}>{paiementIcon}</span><span className="label">Paiement</span></NavLink>) },
            { key: '7', label: (<NavLink to="/reviews-list-partner"><span className="icon" style={{ background: page === "reviews-list-partner" ? color : "" }}>{reviewsIcon}</span><span className="label">Les avis</span></NavLink>) },
            { key: '3', label: (<NavLink to="/Réclamations"><span className="icon" style={{ background: page === "Réclamations" ? color : "" }}>{reclamationsIcon}</span><span className="label">Réclamations</span></NavLink>) },
            { key: 'notifications', label: (<NavLink to="/Notifications"><span className="icon" style={{ background: page === "Notifications" ? color : "" }}><BellOutlined style={{ fontSize: 20, color }} /></span><span className="label">Notifications</span></NavLink>) },
            { key: '4', label: (<NavLink to="/Paramétres"><span className="icon" style={{ background: isSettingsActive ? color : "" }}>{settingsIcon}</span><span className="label">Paramétres</span></NavLink>) },
          ]}
          onClick={async ({ key }) => {
            if (key === '5') {
              try {
                await supabase.auth.signOut();
                window.location.href = '/sign-in';
              } catch (error) {
                console.error('Erreur lors de la déconnexion:', error?.message || error);
              }
            }
          }}
        />
      </div>
    </div>
  );
}

export default memo(SidenavPartner);
